export class GetAllStockable {
  static readonly type = '[stockable] Get All Stockable'
  constructor(public locationId: string) {}
}

export class ReplaceStockables {
  static readonly type = '[stockable] Replace Stockables'
}
